import { useState, useCallback, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryString } from '@shared';
import { COUNTRY, REGION } from '@constant';
import countries from '@root/constant/countries.json';

const countriesData = countries
  .filter((item) => ['EU', 'US'].includes(item.region))
  .sort((a, b) => {
    return a.name.charCodeAt(0) - b.name.charCodeAt(0);
  });

const useSelectCountry = () => {
  const navigate = useNavigate();
  const [country, setCountry] = useState('');
  const { pathname } = useLocation();
  const queryCountry = getQueryString(COUNTRY);
  const queryRegion = getQueryString(REGION);
  const _queryRedirectUrl = getQueryString('redirectUrl');
  const queryRedirectUrl = _queryRedirectUrl
    ? encodeURIComponent(decodeURIComponent(_queryRedirectUrl))
    : '';

  const onClickCountry = useCallback(() => {
    navigate(
      `/selectCountry${
        queryRedirectUrl ? `?redirectUrl=${queryRedirectUrl}` : ''
      }`,
    );
  }, [navigate, queryRedirectUrl]);

  // const checkRegion = useCallback(
  //   (_region: string, _country: string) => {
  //     let region = _region || localStorage.getItem(REGION);
  //     region = region ? region.toLowerCase() : '';
  //     const _baseUrl = `${process.env.REACT_APP_ROUTE_BASE_NAME_PREFIX}${region}`;
  //     if (window.location.pathname.includes(_baseUrl)) {
  //       localStorage.setItem(COUNTRY, _country);
  //       localStorage.setItem(REGION, region);
  //       if (pathname !== '/login') {
  //         navigate('/login', { replace: true });
  //       }
  //     } else if (['eu', 'us'].includes(region)) {
  //       window.location.replace(
  //         `${_baseUrl}/login?${COUNTRY}=${_country}&${REGION}=${region}`,
  //       );
  //     }
  //   },
  //   [navigate, pathname],
  // );

  const checkRegion = useCallback(
    (_region: string, _country: string) => {
      const { origin } = window.location;

      let region = _region || localStorage.getItem(REGION);
      region = region ? region.toLowerCase() : '';

      if (
        origin.includes(`${region}-`) ||
        !(origin.includes('us-') || origin.includes('eu-'))
      ) {
        localStorage.setItem(COUNTRY, _country);
        localStorage.setItem(REGION, region);
        if (pathname !== '/login') {
          navigate(
            `/login${
              queryRedirectUrl ? `?redirectUrl=${queryRedirectUrl}` : ''
            }`,
            { replace: true },
          );
        }
      } else {
        let url = origin;

        if (origin.includes('eu-')) {
          url = origin.replace('eu-', 'us-');
        }

        if (origin.includes('us-')) {
          url = origin.replace('us-', 'eu-');
        }

        window.location.replace(
          `${url}${pathname}?${COUNTRY}=${_country}&${REGION}=${region}${
            queryRedirectUrl ? `&redirectUrl=${queryRedirectUrl}` : ''
          }`,
        );
      }
    },
    [navigate, pathname, queryRedirectUrl],
  );

  const onChange = useCallback(
    (_region: string, _country: string) => {
      checkRegion(_region, _country);
      setCountry(_country);
    },
    [checkRegion],
  );

  useEffect(() => {
    // url 上带着国家和区域，判断是否在当前区域下的站点，不在会进行跳转
    if (queryRegion && queryCountry) {
      checkRegion(queryRegion, queryCountry);
      setCountry(queryCountry);
      return;
    }
    const _localCountry = localStorage.getItem(COUNTRY);
    if (_localCountry) {
      setCountry(_localCountry);
    } else {
      const isEU = window.location.origin.includes('eu-');
      const _c = isEU ? 'AL' : 'US';
      setCountry(_c);
      localStorage.setItem(COUNTRY, _c);
      localStorage.setItem(REGION, isEU ? 'eu' : 'us');
    }
  }, [checkRegion, queryCountry, queryRegion]);

  const countryName = useMemo(() => {
    if (!country) {
      return '';
    }
    return countriesData.find((i) => i.id === country)?.name || '';
  }, [country]);

  return {
    country,
    countryName,
    countriesData,
    onChange,
    onClickCountry,
  };
};

export default useSelectCountry;
